export default {
  planningMapView: {
    baseMap: "Bản đồ nền",
    toolsMap: "Công cụ bản đồ",
    googleMap: "Bản đồ Google",
    satelliteMap: "Bản đồ vệ tinh",
    notUseBaseMap: "Không dùng bản đồ nền",
    mapToolsPanel: {
      viewObjectInfomation: "Xem thông tin đối tượng",
      toggleFullScreen: "Mở rộng/Thu nhỏ",
      zoomIn: "Phóng to bản đồ",
      zoomOut: "Thu nhỏ bản đồ",
      filterInfomation: "Lọc thông tin",
      mapLegend: "Chú giải bản đồ",
      selectAnObject: "Chọn một đối tượng",
      selectMultiObject: "Chọn nhiều đối tượng",
      measuareArea: "Đo diện tích",
      measuareDistance: "Đo khoảng cách",
      moveViewport: "Di chuyển khung nhìn",
      printTheMap: "In bản đồ",
      myPosition: "Xác định vị trí của bạn",
      exportMap: "Xuất bản đồ",
      compare: "So sánh",
      locationMarker: "Đánh dấu vị trí",
      mapReport: "Báo cáo",
      faq: "Câu hỏi thường gặp",
    },
    filterInfomationPopup: {
      headTitle: "Tìm kiếm đối tượng",
      labelSelectSearch: "Chọn đối tượng tìm kiếm",
      searchInLine: "Tìm kiếm trên đường",
      searchInArea: "Tìm kiếm trong vùng",
      searchInCircle: "TÌm kiếm trong đường tròn",
      searchInSquare: "Tìm kiếm trong hình chữ nhật",
      searchWithAttribute: "Theo thuộc tính",
      search: "Tìm kiếm",
      delete: "Xóa",
      close: "Đóng",
    },
  },
  planningMapView_guideToUse: "Hướng dẫn sử dụng",
  planningMapView_guideToUse_category: "Danh mục hướng dẫn",
  planningMapView_map: "Bản đồ",
  planningMapView_infomation: "Thông tin",
  planningMapView_relatedPlanning: "Quy hoạch liên quan",
  planningMapView_result: "Kết quả",
  header_homePage: "Trang chủ",
  header_pleaseConsultTheCommunity: "Xin ý kiến cộng đồng",
  header_lookUpPlanning: "Tra cứu quy hoạch",
  header_news: "Tin tức",
  header_planningAnnouncement: "Công bố quy hoạch",
  header_recordsManager: "Quản lý hồ sơ",
  header_Contact: "Liên hệ",
  header_generalPlanning: "Quy hoạch chung",
  header_syntheticPlanning: "Tổng hợp quy hoạch",
  header_subdivisionPlanning: "Quy hoạch phân khu",
  header_detailedPlanning: "Quy hoạch chi tiết",
  header_specializedPlanning: "Quy hoạch chuyên ngành",
  header_administration: "Quản trị",
  header_logout: "Đăng xuất",
  header_logIn: "Đăng Nhập",
  header_account: "Tài khoản",
  header_title: "CGIS QHT Lâm Đồng",
  footer_title: 'Sở kế hoạch đầu tư <br/>Tỉnh Lâm Đồng',
  footer_titleName: "Sở kế hoạch đầu tư tỉnh Lâm Đồng",
  footer_email: "skhvdt@lamdong.gov.vn",
  footer_address: "Phường Hồng Hà - TP Hạ Long - tỉnh Lâm Đồng",
  footer_hotline: "(0203).3835687",
  footer_fax: "(0203).3838071",
  footer_copyright: "© Bản quyền thuộc về Sở Kế Hoạch Đầu Tư Tỉnh Lâm Đồng",
  contact_hotline: "02033835687",
  contact_hotline_show: "02033835687",
  contact_fax: "0203.3838071",
  contact_email: "sokhdt@lamdong.gov.vn",
  contact_website: "lamdong.gov.vn",
  contact_map_url: "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3723.3678150580618!2d106.60928295038788!3d21.057966785913713!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x314a80c481e4f265%3A0x188a196ffdbcdea2!2zU-G7nyBL4bq_IEhv4bqhY2ggxJDhuqd1IFTGsCBU4buJbmggUXXhuqNuZyBOaW5o!5e0!3m2!1svi!2s!4v1649326202981!5m2!1svi!2s",
    
};
